import {type FunctionalComponent, h} from '@stencil/core';
import {SrtRating} from '../../../result-cards/utils/srt-rating';
import type {SrtDocument} from '../../../../../api/model/response/documents/public/SrtDocument';
import type {SearchApiGenericResult} from '../../../../../api/model/response/documents/SearchResult';
import type { ExstUnionUiModel } from '../../../../../models/ui/documents/exchange/exst-union-ui.model';
import type {Strategies} from '../../../../strategies/Strategies';
import type {InternalAddressesStrategyService} from '../../../../strategies/InternalAddressesStrategyService';
import {INTERNAL_ADDRESSES} from '../../../../strategies/utils/variables';
import type {DocumentBaseUiModel} from '../../../../../models/ui/documents/document-base-ui.model';

export interface GenericCardContainer {
   doc: SearchApiGenericResult | ExstUnionUiModel | DocumentBaseUiModel;
   strategies: Strategies;
   rtl?: boolean;
}

export const EolDiscontinuedCardContainer: FunctionalComponent<GenericCardContainer> = (props, children) => {
    const { doc, strategies, rtl } = props;
    const internalAddressesStrategy:InternalAddressesStrategyService = strategies.for(INTERNAL_ADDRESSES);

    return <div class='eol-result-card__container'
      dir={rtl ? 'rtl' : 'auto'}
      data-card-area={'background'}>
      <a class='eol-result-card__link' href={doc.url}
        target={internalAddressesStrategy.isExternalLink(doc.url) ? '_blank' : '_self'} >
        <div class="result-card__content">
          {children}
        </div>
      </a>
    </div>;
};
